if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          button: this.querySelector("button"),
          panel: this.querySelector(".disclosure__list-wrapper"),
        };
        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this),
        );
        this.elements.button.addEventListener(
          "focusout",
          this.closeSelector.bind(this),
        );
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this)),
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        const code = event.code.toUpperCase();
        if (code === "ESCAPE") {
          if (this.elements.button.getAttribute("aria-expanded") == "false")
            return;
          this.hidePanel();
          event.stopPropagation();
          this.elements.button.focus();
          return;
        }
        // Arrow-down on the button: open the panel and move focus into the first option.
        if (code === "ARROWDOWN" && event.target === this.elements.button) {
          event.preventDefault();
          if (this.elements.button.getAttribute("aria-expanded") === "false") {
            this.openSelector();
          }
          const firstLink = this.elements.panel.querySelector("a");
          if (firstLink) firstLink.focus();
          return;
        }
        // Arrow-down/up between options inside the panel.
        if ((code === "ARROWDOWN" || code === "ARROWUP")
            && this.elements.panel.contains(event.target)) {
          event.preventDefault();
          const links = Array.from(this.elements.panel.querySelectorAll("a"));
          const idx = links.indexOf(event.target);
          if (idx < 0) return;
          const nextIdx = code === "ARROWDOWN"
            ? (idx + 1) % links.length
            : (idx - 1 + links.length) % links.length;
          links[nextIdx].focus();
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
        this.hidePanel();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString(),
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    },
  );
}
